import Modal from "../Modal/Modal";
import {
  Container,
  ContainerMessages,
  MainButton,
} from "./ConfirmationModalListStyled";
interface IConfirmationModalList {
  title: string;
  subTitle: string;
  message: string;
  onAccept: () => void;
  toggleModal: () => void;
  zIndex?: any;
}

export const ConfirmationModalList = (props: IConfirmationModalList) => {
  const { title, message, onAccept, toggleModal, zIndex, subTitle } = props;
  const separator = "|";
  const splitMessage = message.split(separator);
  const messages = Array.isArray(splitMessage) ? splitMessage : [message];

  return (
    <Modal
      zIndex={zIndex}
      onOutsideClick={() => {
        toggleModal();
      }}
    >
      <Container>
        <h1>{title}</h1>
        <p>{subTitle}</p>
        <ContainerMessages>
          {messages.map((message, i) => {
            return (
              <p key={i} style={{ textAlign: "start" }}>
                {message}
              </p>
            );
          })}
        </ContainerMessages>
        <MainButton
          onClick={() => {
            onAccept();
          }}
        >
          Entendido
        </MainButton>
      </Container>
    </Modal>
  );
};
